import { useState } from "react"
import { setCurrentSearchUsername } from "../../../../store/messagingSlice"
import { addPageAction } from "../../../../utils/newrelic"

export const FocusHandler = (
    dispatch: any,
    setText: React.Dispatch<React.SetStateAction<string>>,
    focusCallback?: (focused: boolean) => void,
) => {
    const [focused, setFocused] = useState(false)
    const handleFocus = (newFocused: boolean) => {
        if (focused !== newFocused) {
            setFocused(newFocused)
            focusCallback && focusCallback(newFocused)
            if (!newFocused) {
                setText("")
                dispatch(setCurrentSearchUsername(null))
            } else {
                addPageAction("DmConversationSearch", {
                    actionType: "init",
                })
            }
        }
    }

    return {
        focused,
        handleFocus,
    }
}
